module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_9.8b3424d8.png";